import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/calendar.png'


const _withScopeId = n => (_pushScopeId("data-v-6940468e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container content-start" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bu potansiyel \"İnaktif\" olarak işaretlenmiş. Teknik olarak, bu iş üzerinde değişiklik ve güncellemeler yapabilirsiniz. Ancak uygulama çapında daha verimli kullanılabilmesi için, güncelleme durumunda potansiyeli önce tekrar aktif hale getirmenizi öneririz.", -1))
const _hoisted_3 = {
  key: 2,
  class: "two-column-container sidebar-right col-start-1 col-end-13 mt-14"
}
const _hoisted_4 = { class: "flex items-center gap-4 relative" }
const _hoisted_5 = { class: "w-full py-4 bg-[var(--box-color)] rounded-xl" }
const _hoisted_6 = {
  key: 0,
  class: "assignee-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "Potansiyel Açıklaması", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "Potansiyel Değerlendirmesi", -1))
const _hoisted_9 = { class: "milestones-header flex items-center justify-between" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "Temaslar", -1))
const _hoisted_11 = {
  key: 1,
  class: "text-2xl italic text-gray-400 mb-6"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "İletişim Bilgileri", -1))
const _hoisted_13 = { class: "contact-section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "Güncellemeler", -1))
const _hoisted_15 = { class: "updates-container" }
const _hoisted_16 = {
  key: 0,
  class: "comments-container"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl italic text-gray-400 mb-6" }, "Bu potansiyel için herhangi bir güncelleme eklenmemiş. Potansiyeli daha verimli takip etmek için belli aralıklarla güncellemeler paylaşabilirsiniz.", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: ""
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-6" }, "İşlemler", -1))
const _hoisted_22 = { class: "potential-buttons" }
const _hoisted_23 = { class: "potential-information mt-[3.6rem] border border-gray-300 rounded-xl p-4 flex flex-col gap-6" }
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Potansiyel Derecesi", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_27 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Potansiyel Tipi:", -1))
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "flex items-center gap-2 text-2xl relative" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Öncelik:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "LOW" }, "Düşük", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "STANDARD" }, "Standart", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "HIGH" }, "Yüksek", -1))
const _hoisted_35 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "flex items-center gap-2 text-2xl"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Keşfeden:", -1))
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = {
  key: 1,
  class: "flex items-center gap-2 text-2xl"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Öneren: ", -1))
const _hoisted_41 = { class: "mb-0" }
const _hoisted_42 = { class: "potential-meta mt-[3.6rem] border border-gray-300 rounded-xl p-4 flex flex-col gap-6" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Ekleme Bilgileri", -1))
const _hoisted_44 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "mb-0" }
const _hoisted_47 = { class: "flex items-center gap-3 text-2xl" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-8 filter-main",
  src: _imports_0,
  alt: "Calendar Icon"
}, null, -1))
const _hoisted_49 = { class: "mb-0" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0 mt-8" }, "Takibe Alınma Bilgileri", -1))
const _hoisted_51 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "mb-0" }
const _hoisted_54 = { class: "flex items-center gap-3 text-2xl" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-8 filter-main",
  src: _imports_0,
  alt: "Calendar Icon"
}, null, -1))
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-8" }, null, -1))
const _hoisted_58 = { class: "latest-update-container" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "Son Güncelleme", -1))
const _hoisted_60 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_64 = { class: "mb-0" }

import type { ColorMetaField } from '@/types/metas'
import type { AcContactData, AcPotential, AcMilestone, AcTrackedPotential } from '@/types/crm'
import type { AcReminder } from '@/types/application'
import type { fetchedUser } from '@/types/fetchedUser'

import {ref, computed, onBeforeMount, onBeforeUnmount} from 'vue'
import { useFetchRealTimeTrackedPotential, postCRMReminder, getStrategyResponse, getActionMapResponse } from '@/composables/crmBasedFunctions'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useGetDocs } from '@/mixins/modularFirebaseOperations'
import { formatUser, modalClosed, formatDate } from '@/mixins/visualFormatters'
import { updateSingleField, addSingleArrayItem, removeSingleArrayItem } from '@/mixins/modularFirebaseOperations'
import { trackLastUpdate } from '@/composables/loggers'
import resetBackground from "@/mixins/resetBackground";
import removeBackground from "@/mixins/removeBackground";

// Import available reusable components
import ModernStatusChip from '@/components/reusable/modernStatusChip.vue'
import StarPicker from '@/components/reusable/starPicker.vue'
import CommentListDisplayer from '@/components/reusable/commentListDisplayer.vue'
import AcMediumModal from '@/components/reusable/teleports/acMediumModal.vue'
import StatusBar from '@/components/reusable/statusBar.vue'
import ContactDisplayer from '@/components/reusable/contactDisplayer.vue'
import AddReminderForm from '@/components/crm-components/addReminderForm.vue'
import CommentField from '@/components/reusable/commentField.vue'
import EditableTitle from '@/components/reusable/editableTitle.vue'
import EditableTextarea from '@/components/reusable/editableTextarea.vue'
import UserDisplay from '@/components/reusable/userDisplay.vue'
import StatusChanger from '@/components/reusable/statusChanger.vue'
import MilestoneDisplayer from '@/components/crm-components/milestoneDisplayer.vue'
import AddMilestoneForm from '@/components/crm-components/addMilestoneForm.vue'
import AccaVueNotification from '@/components/reusable/accaVueNotification.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'trackedDetail',
  setup(__props) {


const potentialId = useRoute().params.id

const { trackedPotential, isLoadingTrackedPotential } = useFetchRealTimeTrackedPotential(potentialId as string)
//Eslint ignore no-unused-vars
//eslint-disable-next-line
const { docs, isLoadingDocs } = useGetDocs(`crm/jobCategories/list`)

const isPickingNewCategory = ref(false)
const isAddingMilestone = ref(false)
const isAddingReminder = ref(false)
const isDisplayingPriortiySwitcher = ref(false)
const store = useStore()
const userProfile = computed(() => store.getters['user/userProfile'])
const formattedUser = computed(() => formatUser(userProfile.value))
const aiActive = ref(false)

const determinePriorityDisplay = computed(() => {
    if(trackedPotential.value?.priority === "LOW"){
        return "Düşük"
    }
    if(trackedPotential.value?.priority === "STANDARD"){
        return "Standart"
    } else if(trackedPotential.value?.priority === "HIGH"){
        return "Yüksek"
    }
    return "Standart"
})



const updateSinglePotentialField = async (field: string, value: string) => {
    await updateSingleField(
        `crm/tracked/list/${potentialId}`,
        field,
        value,
    )
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const updatePotentialCategories = async (category: ColorMetaField) => {
    await addSingleArrayItem(
        `crm/tracked/list/${potentialId}`,
        "potentialCategories",
        category
    )
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const addUserToPotential = async (user: fetchedUser) => {
    await addSingleArrayItem(
        `crm/tracked/list/${potentialId}`,
        "assignedTo",
        user
    )
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const addCommentToPotential = async (comment: string) => {

    const commentObj = {
        comment: comment,
        date: new Date(),
        user: formattedUser.value
    }

    await addSingleArrayItem(
        `crm/tracked/list/${potentialId}`,
        "comments",
        commentObj
    )
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const removeUserFromPotential = async (user: fetchedUser) => {
    await removeSingleArrayItem(
        `crm/tracked/list/${potentialId}`,
        "assignedTo",
        user
    )
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const handleContactAdded = async (contact: AcContactData) => {
    const currentContacts = trackedPotential.value?.contact || []
    const updatedContacts = [...currentContacts, contact]
    
    await updateSingleField(
        `crm/tracked/list/${potentialId}`,
        "contact",
        updatedContacts,
    )
    
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const handleContactDeleted = async (contact: AcContactData) => {
    if (!trackedPotential.value?.contact) return
    
    // Filter out the deleted contact
    const updatedContacts = trackedPotential.value.contact.filter(existingContact => {
        return !(existingContact.title === contact.title && 
                existingContact.emailAddress === contact.emailAddress &&
                existingContact.phoneNumber === contact.phoneNumber)
    })
    
    await updateSingleField(
        `crm/tracked/list/${potentialId}`,
        "contact",
        updatedContacts,
    )
    
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const handleContactUpdated = async (updatedContact: AcContactData, originalContact: AcContactData) => {
    if (!trackedPotential.value?.contact) return
    
    // Find and replace the original contact with the updated one
    const updatedContacts = trackedPotential.value.contact.map(contact => {
        // Compare contacts by their properties to find the match
        if (contact.title === originalContact.title && 
            contact.emailAddress === originalContact.emailAddress &&
            contact.phoneNumber === originalContact.phoneNumber) {
            return updatedContact
        }
        return contact
    })
    
    // Update the entire contact array
    await updateSingleField(
        `crm/tracked/list/${potentialId}`,
        "contact",
        updatedContacts,
    )
    
    await trackLastUpdate(
        `crm/tracked/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

// Potential actions

const addReminder = () => {

    console.log(trackedPotential.value?.assignedTo)
    
    if(trackedPotential.value?.assignedTo.length === 0){
        alert("Bu potansiyel için hiçbir sorumlu eklenmediği için hatırlatma ekleyemezsiniz. Lütfen önce sorumlu ekleyiniz.")
        return
    } 

    isAddingReminder.value = true

}

const handleReminderAdded = async (reminder: Partial<AcReminder>) => {
    

    if(trackedPotential.value?.assignedTo.length === 0){
        alert("Bu potansiyel için hiçbir sorumlu eklenmediği için hatırlatma ekleyemezsiniz. Lütfen önce sorumlu ekleyiniz.")
        return
    }

    try{
        await postCRMReminder(
            reminder.additionalMessage,
            reminder.date,
            trackedPotential.value as AcPotential,
            "tracked-detail"
        )
    } catch (error) {
        alert(`Hatırlatma eklenirken bir hata oluştu: ${error}. Lütfen bu hatayı yazılım ekibiniz ile paylaşın.`)
    } finally {
        isAddingReminder.value = false
        modalClosed()
    }
}

const handleMilestoneAdded = async (milestone: AcMilestone) => {
    try {
        await addSingleArrayItem(
            `crm/tracked/list/${potentialId}`,
            "milestones",
            milestone
        )
        await trackLastUpdate(
            `crm/tracked/list/${potentialId}`,
            {
                date: new Date(),
                user: formattedUser.value
            }
        )

    } catch (error) {
        alert("Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.")
    } finally {
        isAddingMilestone.value = false
        modalClosed()
    }
}

const handleMilestoneDeleted = async (milestone: AcMilestone) => {
    const confirmation = confirm("Bu teması silmek istediğinize emin misiniz?")
    if(confirmation){
    try {
        await removeSingleArrayItem(
            `crm/tracked/list/${potentialId}`,
            "milestones",
            milestone
        )
        await trackLastUpdate(
            `crm/tracked/list/${potentialId}`,
            {
                date: new Date(),   
                user: formattedUser.value
            }
        )
    } catch (error) {
        console.error(error)
        }
    }
}

const handlePotentialCategoryDeleted = async (categoryId: string) => {
    const category = trackedPotential.value?.potentialCategories.find((category: ColorMetaField) => category.id === categoryId)

    if(category){
        try {
            await removeSingleArrayItem(
                `crm/tracked/list/${potentialId}`,
                "potentialCategories",
                category
            )
            await trackLastUpdate(
                `crm/tracked/list/${potentialId}`,
                {
                    date: new Date(),
                    user: formattedUser.value
                }
            )

            
        } catch (error) {
            console.error(error)
        }
    }
}

// AI Features

const isValidForAI = () => {

    let hasEvaluation: boolean;
    console.log("Evaluation",trackedPotential.value?.evaluation)
    if(trackedPotential.value?.evaluation.length > 100){
        console.log("Evaluation is long enough")
        if(trackedPotential.value?.evaluation === 'Satış süreçleri, teknik konulara ve gerçek ihtiyaçlara dayandığı kadar müşterilerin kişisel özelliklerine, onları ne kadar tanıdığınıza ve müşterilerin size karşı yaklaşımına dayanır. Bu bölümde, müşterinin kişisel özellikleri, beklentileri ve bugüne kadar yaşanan temaslardaki tavırları konusunda detaylı bilgiler girebilirsiniz.'){
            hasEvaluation = false
        } else {
            hasEvaluation = true
        }
    } else {
        hasEvaluation = false
    }

    const hasDescription = trackedPotential.value?.description.length > 100
    const hasMilestones = trackedPotential.value?.milestones.length > 0
    const hasComments = trackedPotential.value?.comments.length > 0

    if(hasEvaluation && hasDescription && hasMilestones && hasComments){
        return true
    } else if (trackedPotential.value?.description.length > 350 && trackedPotential.value?.evaluation.length > 350){
        return true
    } else {
        return false
    }
}

const sendStrategyRequest = () => {
    const valid = isValidForAI()
    if(!valid){
        alert("AI altyapımız, yalnızca üzerinde çalışılmış ve gerekli bilgileri doldurulmuş potansiyeller için devreye girebilmektedir. Lütfen açıklama ve değerlendirme kısımlarını detaylandırarak, daha fazla güncelleme ve temas girerek tekrar deneyiniz.")
        return
    }
    aiActive.value = true
    getStrategyResponse(trackedPotential.value as AcTrackedPotential)
    setTimeout(() => {
        aiActive.value = false
    }, 2000)

}

const sendActionMapRequest = () => {
    const valid = isValidForAI()
    if(!valid){
        alert("AI altyapımız, yalnızca üzerinde çalışılmış ve gerekli bilgileri doldurulmuş potansiyeller için devreye girebilmektedir. Lütfen açıklama ve değerlendirme kısımlarını detaylandırarak, daha fazla güncelleme ve temas girerek tekrar deneyiniz.")
        return
    }
    aiActive.value = true
    getActionMapResponse(trackedPotential.value as AcTrackedPotential)
    setTimeout(() => {
        aiActive.value = false
    }, 2000)
}

const sendIntroMail = () => {
    alert("Tanıtım belgesi gönderme özelliği şu anda yapım aşamasındadır. Lütfen daha sonra tekrar deneyiniz.")
}

onBeforeMount(() => {
    removeBackground.methods.removeBackground()
})

onBeforeUnmount(() => {
    resetBackground.methods.resetBackground()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (aiActive.value)
      ? (_openBlock(), _createBlock(AccaVueNotification, {
          key: 0,
          message: "Dansuk AI sizin için bir strateji oluşturuyor. Hazır olduğunda otomatik olarak 'Güncellemeler' kısmında göreceksiniz.",
          selectedType: "success"
        }))
      : _createCommentVNode("", true),
    (_unref(trackedPotential)?.status === 'INACTIVE')
      ? (_openBlock(), _createBlock(StatusBar, {
          key: 1,
          backgroundColor: '#021640',
          class: "col-start-1 col-end-13 !w-full !mb-0 !mt-8"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(isLoadingTrackedPotential))
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("main", null, [
            _createElementVNode("header", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(trackedPotential)?.potentialCategories, (category) => {
                return (_openBlock(), _createBlock(ModernStatusChip, {
                  onDeleteClicked: _cache[0] || (_cache[0] = ($event: any) => (handlePotentialCategoryDeleted($event))),
                  "is-deletable": true,
                  key: category.id,
                  "bg-colors": { [category.id]: category.color },
                  value: category.id,
                  text: category.name
                }, null, 8, ["bg-colors", "value", "text"]))
              }), 128)),
              _createElementVNode("button", {
                class: "ac-square-button bg-black hover-bg-[#021640] text-white rounded-lg text-xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isPickingNewCategory.value = true))
              }, "+"),
              (isPickingNewCategory.value)
                ? (_openBlock(), _createBlock(StatusChanger, {
                    key: 0,
                    "changer-title": "Kategori Seç",
                    "status-list": _unref(docs),
                    "bg-colors": _unref(docs).map((category) => category.color),
                    "is-changeable": true,
                    "ac-position": "[400, 40]",
                    onCancelled: _cache[2] || (_cache[2] = ($event: any) => (isPickingNewCategory.value = false)),
                    onUpdated: _cache[3] || (_cache[3] = ($event: any) => (updatePotentialCategories($event)))
                  }, null, 8, ["status-list", "bg-colors"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(EditableTitle, {
              class: "mt-1 !mb-8",
              onTitleEdited: _cache[4] || (_cache[4] = ($event: any) => (updateSinglePotentialField('title', $event))),
              text: _unref(trackedPotential)?.title
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(trackedPotential)?.assignedTo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(UserDisplay, {
                      onUserAdded: _cache[5] || (_cache[5] = ($event: any) => (addUserToPotential($event))),
                      onUserRemoved: _cache[6] || (_cache[6] = ($event: any) => (removeUserFromPotential($event))),
                      class: "px-4",
                      "show-add-button": true,
                      "add-button-text": "Sorumlu Ekle",
                      "empty-state-text": "Bu potansiyel için hiçbir sorumlu eklenmemiş. Sorumlular ekleyerek bu potansiyeli daha iyi takip edebiliriz.",
                      "empty-state-icon": "~/assets/icons/no-user.png",
                      "allow-remove": true,
                      "allow-add": true,
                      "show-user-names": false,
                      "image-size": 'smaller',
                      users: _unref(trackedPotential)?.assignedTo
                    }, null, 8, ["users"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_7,
            _createVNode(EditableTextarea, {
              class: "!mt-[2.4rem]",
              onEditCancelled: () => { },
              onEditCompleted: _cache[7] || (_cache[7] = ($event: any) => (updateSinglePotentialField('description', $event))),
              text: _unref(trackedPotential)?.description
            }, null, 8, ["text"]),
            _hoisted_8,
            _createVNode(EditableTextarea, {
              class: "!mt-[2.4rem]",
              onEditCancelled: () => { },
              onEditCompleted: _cache[8] || (_cache[8] = ($event: any) => (updateSinglePotentialField('evaluation', $event))),
              text: _unref(trackedPotential)?.evaluation
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("button", {
                class: "ac-add-button text-2xl",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (isAddingMilestone.value = true))
              }, "Yeni Temas Ekle")
            ]),
            (_unref(trackedPotential)?.milestones && _unref(trackedPotential).milestones.length > 0)
              ? (_openBlock(), _createBlock(MilestoneDisplayer, {
                  key: 0,
                  milestones: _unref(trackedPotential).milestones,
                  "icon-size": '3rem',
                  onDeleteMilestone: _cache[10] || (_cache[10] = ($event: any) => (handleMilestoneDeleted($event)))
                }, null, 8, ["milestones"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, "Bu potansiyel için hiçbir temas eklenmemiş. Önemli süreçler yaşandıkça yeni temaslar ekleyebilirsiniz. ")),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(ContactDisplayer, {
                cols: 3,
                "is-multiple": true,
                "is-editable": true,
                "is-deletable": true,
                "show-icons": true,
                "show-qr-code": true,
                "contact-qr-title": _unref(trackedPotential)?.title,
                "show-add-button": true,
                "contact-data": _unref(trackedPotential)?.contact,
                onContactUpdated: handleContactUpdated,
                onContactDeleted: _cache[11] || (_cache[11] = ($event: any) => (handleContactDeleted($event))),
                onContactAdded: _cache[12] || (_cache[12] = ($event: any) => (handleContactAdded($event)))
              }, null, 8, ["contact-qr-title", "contact-data"])
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_unref(trackedPotential)?.comments.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(CommentListDisplayer, {
                      comments: _unref(trackedPotential)?.comments
                    }, null, 8, ["comments"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            ]),
            _createVNode(CommentField, {
              class: "!mt-[4.8rem] w-3/4 pb-24",
              onCommentSubmitted: _cache[13] || (_cache[13] = ($event: any) => (addCommentToPotential($event))),
              text: _unref(trackedPotential)?.comments,
              placeholder: "Yorumunuzu buraya yazın veya iptal etmek için 'esc' tuşuna basın."
            }, null, 8, ["text"])
          ]),
          (!_unref(isLoadingTrackedPotential))
            ? (_openBlock(), _createElementBlock("aside", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    onClick: sendStrategyRequest,
                    class: "ac-primary-button w-full text-2xl mb-4"
                  }, " Strateji Oluştur "),
                  _createElementVNode("button", {
                    onClick: sendActionMapRequest,
                    class: "ac-primary-button w-full text-2xl mb-4"
                  }, " Aksiyon Haritası Çıkart "),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (addReminder())),
                    class: "ac-secondary-button w-full text-2xl mb-4"
                  }, " Hatırlatma Ekle "),
                  _createElementVNode("button", {
                    class: "ac-secondary-button w-full text-2xl mb-4",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (sendIntroMail()))
                  }, " Tanıtım Belgesi Gönder "),
                  (_unref(trackedPotential)?.status === 'ACTIVE')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (updateSinglePotentialField('status', 'INACTIVE'))),
                        class: "ac-secondary-button w-full text-2xl mb-4"
                      }, " Deaktif Hale Getir "))
                    : _createCommentVNode("", true),
                  (_unref(trackedPotential)?.status === 'INACTIVE')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (updateSinglePotentialField('status', 'ACTIVE'))),
                        class: "ac-secondary-button w-full text-2xl mb-4"
                      }, " Aktif Hale Getir "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(StarPicker, {
                      "picked-quantity": _unref(trackedPotential)?.potentialRating!,
                      "max-quantity": 5,
                      "onUpdate:pickedQuantity": _cache[18] || (_cache[18] = ($event: any) => (updateSinglePotentialField('potentialRating', $event)))
                    }, null, 8, ["picked-quantity"])
                  ]),
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(trackedPotential)?.type === "company" ? "Şirket" : "Kişi"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    (isDisplayingPriortiySwitcher.value)
                      ? (_openBlock(), _createElementBlock("select", {
                          key: 0,
                          onChange: _cache[19] || (_cache[19] = ($event: any) => (updateSinglePotentialField('priority', $event.target.value))),
                          class: "absolute top-0 left-0 w-full h-full opacity-0"
                        }, _hoisted_35, 32))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (isDisplayingPriortiySwitcher.value = !isDisplayingPriortiySwitcher.value)),
                      class: "mb-0 cursor-pointer"
                    }, _toDisplayString(determinePriorityDisplay.value), 1)
                  ]),
                  (_unref(trackedPotential)?.referredBy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(trackedPotential)?.referredBy.userName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(trackedPotential)?.thirdPartyRefferrer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(trackedPotential).thirdPartyRefferrer), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("img", {
                      src: _unref(trackedPotential)?.addedBy.profileImage,
                      referrerpolicy: "no-referrer",
                      alt: "Profile Image",
                      class: "rounded-image-mini rounded-full"
                    }, null, 8, _hoisted_45),
                    _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(trackedPotential)?.addedBy.userName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(formatDate)(_unref(trackedPotential)?.createdAt.toDate())), 1)
                  ]),
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("img", {
                      src: _unref(trackedPotential)?.trackedBy.profileImage,
                      referrerpolicy: "no-referrer",
                      alt: "Profile Image",
                      class: "rounded-image-mini rounded-full"
                    }, null, 8, _hoisted_52),
                    _createElementVNode("p", _hoisted_53, _toDisplayString(_unref(trackedPotential)?.trackedBy.userName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("p", _hoisted_56, _toDisplayString(_unref(formatDate)(_unref(trackedPotential)?.trackedAt.toDate())), 1)
                  ]),
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("img", {
                        src: _unref(trackedPotential)?.updatedAt.user.profileImage,
                        referrerpolicy: "no-referrer",
                        alt: "Profile Image",
                        class: "rounded-image-mini rounded-full"
                      }, null, 8, _hoisted_61),
                      _createElementVNode("p", _hoisted_62, _toDisplayString(_unref(trackedPotential)?.updatedAt.user.userName), 1),
                      _hoisted_63,
                      _createElementVNode("p", _hoisted_64, _toDisplayString(_unref(formatDate)(_unref(trackedPotential)?.updatedAt.date.toDate())), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingReminder.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                onModalClosed: _cache[23] || (_cache[23] = ($event: any) => {isAddingReminder.value = false; _unref(modalClosed)()}),
                class: "lg:!top-44 overflow-y-scroll",
                title: "Hatırlatma Ekle",
                width: "50vw",
                height: "fit-content"
              }, {
                default: _withCtx(() => [
                  _createVNode(AddReminderForm, {
                    onReminderAdded: _cache[21] || (_cache[21] = ($event: any) => (handleReminderAdded($event))),
                    onCancelled: _cache[22] || (_cache[22] = ($event: any) => {isAddingReminder.value = false; _unref(modalClosed)();})
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingMilestone.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                onModalClosed: _cache[25] || (_cache[25] = ($event: any) => {isAddingMilestone.value = false; _unref(modalClosed)()}),
                class: "lg:!top-44 overflow-y-scroll",
                title: "Yeni Temas Ekle",
                width: "50vw",
                height: "fit-content"
              }, {
                default: _withCtx(() => [
                  _createVNode(AddMilestoneForm, {
                    onMilestoneAdded: handleMilestoneAdded,
                    onCancelled: _cache[24] || (_cache[24] = ($event: any) => {isAddingMilestone.value = false; _unref(modalClosed)();})
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})